import React from 'react'
import PropTypes from 'prop-types'
import { CardValue, LocalizedDateTime, LocalizedText, Rows, Columns } from 'labguard-cdk'
import { LocalizedUserName } from 'src/components/common'

const AckComment = ({ alarm }) => (
  <Rows>
    <Columns>
      <CardValue title={<LocalizedText id="WEB_ACKNOWLEDGE_DATE" />}>
        <LocalizedDateTime value={alarm.ackDate} />
      </CardValue>
      <CardValue title={<LocalizedText id="WEB_ACKNOWLEDGE_NOTE" />}>{alarm.ackComment.label}</CardValue>
    </Columns>
    <CardValue row title={<LocalizedText id="WEB_ACTORS" />}>
      <LocalizedUserName values={alarm.ackUser} />
    </CardValue>
  </Rows>
)

AckComment.propTypes = {
  alarm: PropTypes.shape({
    ackDate: PropTypes.instanceOf(Date),
    ackComment: PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
    }),
    ackUser: PropTypes.shape({
      id: PropTypes.string,
      firstname: PropTypes.string,
      lastname: PropTypes.string,
    }),
  }),
}

export default AckComment
